import { Pipe, PipeTransform } from '@angular/core';
import { ContentService } from '../../services/content/content.service';
import { Models } from '@ibexfusion/models';

@Pipe({
  name: 'socialMediaFeedPipe'
})
export class SocialMediaFeedPipe implements PipeTransform {
  constructor(private contentService: ContentService) {
  }

  transform(entry: Models.ContentEntry): Models.SocialMediaFeedEntry | Models.SocialMediaFeedEntry[] {
    const entries: Models.SocialMediaFeedEntry = new Models.SocialMediaFeedEntry();
    entries.posts = [];
    if (!entry || !entry.related || !entry.related.entries || entry.related.entries.length === 0) {
      return null;
    }
    if (entry.related && entry.related.entries && entry.related.entries.length > 0) {
      for (const item of entry.related.entries) {
        if (!this.contentService.getEntry(item.id)) {
          continue;
        }
        const contentEntry: any = this.contentService.getEntry(item.id);
        if (contentEntry && contentEntry.detail
          && contentEntry.files && contentEntry.files.length) {
          let file = this.contentService.getFile(contentEntry.files[0].id);
          if (file && file.url) {
            contentEntry.detail.image = file.url;
          }
        }
        const socialMediaFeedContentEntry: any = new Models.SocialMediaFeedContentEntry();
        socialMediaFeedContentEntry.populateFromJSON({
          title: contentEntry.title,
          description: contentEntry.detail.description,
          media: contentEntry.detail.image ? [{
            URL: contentEntry.detail.image,
            type: 'image',
            sourceId: contentEntry.files[0].id
          }] : [],
          type: contentEntry.detail.type,
          link: contentEntry.detail.url
        });
        entries.posts.push(socialMediaFeedContentEntry);
      }
      return entries;
    }
  }
}
